
import { URL } from '../../util/ambienteActions';
import axios from 'axios';
import { LISTAR_FILTROS_ENCOMENDA } from '../types';

export const  listarFiltrosEncomenda = idEmpresa => dispatch => axios.get(`${URL}/encomendas/empresa/${idEmpresa}/filtros-geral`)
    .then(response => dispatch({
        type: LISTAR_FILTROS_ENCOMENDA,
        payload: response
      })
    )